<script setup>
import {ref, watch} from 'vue';
import {formatUSD} from "@utilities/helpers.ts";
import ReportTableBox from "@components/reports/EOD/ReportTableBox.vue";

const props = defineProps({
  editing: Boolean,
  modelValue: Array,
  total: Number,
  totalSales: Number
});

const emit = defineEmits(['updateDataTable']);
const localDataTable = ref(Object.entries(props.modelValue));

watch(localDataTable, (newValue) => {
  emit('updateDataTable', newValue);
}, {deep: true});
</script>

<template>
  <ReportTableBox title="Service Sales">
    <DataTable :value="modelValue" size="small" class="custom-table w-full">
      <Column field="price">
        <template #header>
          <span class="pl-4 font-semibold">Price</span>
        </template>
        <template #body="{data, field}">
          <span class="pl-4">{{ formatUSD(data[field]) }}</span>
        </template>
      </Column>
      <Column field="amount">
        <template #header>
          <div class="flex justify-center items-center w-full">
            <span class="text-center font-semibold">Amt</span>
          </div>
        </template>
        <template #body="{data, field}">
          <div class="flex justify-center items-center">
            <InputNumber :min="0" v-if="editing" class="sleek-input" v-model="data[field]" autofocus fluid/>
            <span v-else class="m-0">
              {{ data[field] }}
            </span>
          </div>
        </template>
      </Column>
      <Column field="total">
        <template #header>
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            <span class="text-end font-semibold">Total</span>
          </div>
        </template>
        <template #body="{data}">
          <div class="flex justify-end items-center w-full md:pr-4 pr-0">
            <span>{{ formatUSD((parseInt(data.amount) * parseFloat(data.price)) ?? 0) }}</span>
          </div>
        </template>
      </Column>
      <ColumnGroup type="footer">
        <Row>
          <Column>
            <template #footer>
              <span class="font-semibold md:pl-4 pl-0">Total</span>
            </template>
          </Column>
          <Column>
            <template #footer>
              <div class="flex justify-center items-center w-full">
                <span class="font-semibold text-center">{{ total }}</span>
              </div>
            </template>
          </Column>
          <Column>
            <template #footer>
              <div class="flex justify-end items-center w-full md:pr-4 pr-0">
                <span class="font-semibold text-end">{{ formatUSD(totalSales) }}</span>
              </div>
            </template>
          </Column>
        </Row>
      </ColumnGroup>
    </DataTable>
  </ReportTableBox>
</template>
